import { BasicTooltip, ExpandedTooltip, getUtility, Icon } from '@livable/saas-react-components';
import { Button, IconButton, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import AllocationPreviewModal from 'src/components/statements/AllocationPreviewModal';
import useStyles from './styles';
import { FEE_TYPES_NAME, TRANSACTION_TYPES, TRANSACTION_TYPESV2 } from 'src/constants/payments';
export const StatementsBlock = observer(props => {
  const history = useLocation();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _props$hideNotes = props.hideNotes,
    hideNotes = _props$hideNotes === void 0 ? false : _props$hideNotes,
    isFinalStatement = props.isFinalStatement,
    title = props.title,
    subTitle = props.subTitle,
    charges = props.charges,
    total = props.total;
  const urlParams = new URLSearchParams(history.search);
  const propertyId = urlParams.get('propertyId');

  // const getIcon = type => {
  //   switch (type) {
  //     case 'charge':
  //     case 'recurring-charge':
  //       return <Icon svgType="static" type="arrow-down-circle" />;
  //     case 'credit':
  //     case 'recurring-credit':
  //       return <Icon svgType="static" type="arrow-up-circle" />;
  //   }
  // };

  const getTitle = (type, charge) => {
    switch (type) {
      case 'charge':
        return t('statements.charge');
      case 'recurring-charge':
        return t('statements.recurring_charge');
      case 'credit':
        return t('resident_account.cap_credit');
      case 'recurring-credit':
        return t('statements.recurring_credit');
      case 'fee':
        return t('statements.fee_charge');
      default:
        return (charge === null || charge === void 0 ? void 0 : charge.title) || '';
    }
  };
  const getChargeAmount = charge => {
    if (charge.isSkipped) {
      return 'Skipped';
    } else if (charge.isOptOut) {
      return 'Is Opted out';
    } else {
      return "$".concat(Number(charge.amount).toFixed(2));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.statement
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.statementHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, title), subTitle && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, subTitle)), charges === null || charges === void 0 ? void 0 : charges.map(charge => {
    var _charge$relatedTransa, _charge$relatedTransa2, _charge$relatedTransa3, _charge$relatedTransa4, _charge$relatedTransa5, _charge$relatedTransa6, _charge$relatedTransa7, _charge$relatedTransa8, _charge$relatedTransa9, _charge$relatedTransa0, _charge$relatedTransa1, _charge$relatedTransa10, _charge$relatedTransa11, _charge$relatedTransa12, _charge$metadata, _charge$metadata2;
    const utilityData = getUtility(charge.utilityTypeName);
    return /*#__PURE__*/React.createElement("div", {
      className: classes.statementRow,
      key: (charge === null || charge === void 0 ? void 0 : charge.utilityId) + '_' + (charge === null || charge === void 0 ? void 0 : charge.type)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.flex
    }, charge.utilityTypeName && charge.type !== 'credit' && utilityData.icon({
      svgType: 'static'
    }), (charge === null || charge === void 0 ? void 0 : charge.type) && (charge === null || charge === void 0 ? void 0 : charge.type) !== TRANSACTION_TYPESV2.UtilityCharge && /*#__PURE__*/React.createElement(Icon, {
      svgType: "static",
      type: "coins-in-hand"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.statementRowDesc
    }, charge.utilityId && /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, utilityData.title, (charge === null || charge === void 0 ? void 0 : charge.type) === 'credit' && ' ' + t('resident_account.cap_credit')), charge.description || charge.type && charge.type !== 'credit' && /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, charge.description || TRANSACTION_TYPES[charge.type] || charge.type), charge.type === TRANSACTION_TYPESV2.Void && (charge === null || charge === void 0 || (_charge$relatedTransa = charge.relatedTransactionData) === null || _charge$relatedTransa === void 0 ? void 0 : _charge$relatedTransa.type) === TRANSACTION_TYPESV2.UtilityCharge ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, (charge === null || charge === void 0 || (_charge$relatedTransa2 = charge.relatedTransactionData) === null || _charge$relatedTransa2 === void 0 ? void 0 : _charge$relatedTransa2.type) === TRANSACTION_TYPESV2.UtilityCharge && TRANSACTION_TYPES[charge === null || charge === void 0 || (_charge$relatedTransa3 = charge.relatedTransactionData) === null || _charge$relatedTransa3 === void 0 ? void 0 : _charge$relatedTransa3.type] + ': ', charge === null || charge === void 0 || (_charge$relatedTransa4 = charge.relatedTransactionData) === null || _charge$relatedTransa4 === void 0 ? void 0 : _charge$relatedTransa4.utilityTypeName), (charge === null || charge === void 0 || (_charge$relatedTransa5 = charge.relatedTransactionData) === null || _charge$relatedTransa5 === void 0 ? void 0 : _charge$relatedTransa5.type) === TRANSACTION_TYPESV2.UtilityCharge && /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "light",
      className: classes.hideMobile
    }, t('resident_account.service_dates'), ' ', moment(charge === null || charge === void 0 || (_charge$relatedTransa6 = charge.relatedTransactionData) === null || _charge$relatedTransa6 === void 0 ? void 0 : _charge$relatedTransa6.metadata.serviceStartDateOnly).format('MM/DD/YYYY') + ' - ' + moment(charge === null || charge === void 0 || (_charge$relatedTransa7 = charge.relatedTransactionData) === null || _charge$relatedTransa7 === void 0 ? void 0 : _charge$relatedTransa7.metadata.serviceEndDateOnly).format('MM/DD/YYYY'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, FEE_TYPES_NAME[charge === null || charge === void 0 || (_charge$relatedTransa8 = charge.relatedTransactionData) === null || _charge$relatedTransa8 === void 0 || (_charge$relatedTransa8 = _charge$relatedTransa8.metadata) === null || _charge$relatedTransa8 === void 0 ? void 0 : _charge$relatedTransa8.feeType] || (charge === null || charge === void 0 || (_charge$relatedTransa9 = charge.relatedTransactionData) === null || _charge$relatedTransa9 === void 0 || (_charge$relatedTransa9 = _charge$relatedTransa9.metadata) === null || _charge$relatedTransa9 === void 0 ? void 0 : _charge$relatedTransa9.feeType) || (charge === null || charge === void 0 || (_charge$relatedTransa0 = charge.relatedTransactionData) === null || _charge$relatedTransa0 === void 0 ? void 0 : _charge$relatedTransa0.type) && (TRANSACTION_TYPES[charge === null || charge === void 0 || (_charge$relatedTransa1 = charge.relatedTransactionData) === null || _charge$relatedTransa1 === void 0 ? void 0 : _charge$relatedTransa1.type] || (charge === null || charge === void 0 || (_charge$relatedTransa10 = charge.relatedTransactionData) === null || _charge$relatedTransa10 === void 0 ? void 0 : _charge$relatedTransa10.type)) + "".concat(charge !== null && charge !== void 0 && (_charge$relatedTransa11 = charge.relatedTransactionData) !== null && _charge$relatedTransa11 !== void 0 && (_charge$relatedTransa11 = _charge$relatedTransa11.metadata) !== null && _charge$relatedTransa11 !== void 0 && _charge$relatedTransa11.title ? ': ' + (charge === null || charge === void 0 || (_charge$relatedTransa12 = charge.relatedTransactionData) === null || _charge$relatedTransa12 === void 0 || (_charge$relatedTransa12 = _charge$relatedTransa12.metadata) === null || _charge$relatedTransa12 === void 0 ? void 0 : _charge$relatedTransa12.title) : ''))), charge.startDateOnly && /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "light",
      className: classes.hideMobile
    }, t('resident_account.service_dates'), ' ', moment(charge.startDateOnly).format('MM/DD/YYYY') + ' - ' + moment(charge.endDateOnly).format('MM/DD/YYYY')), ((_charge$metadata = charge.metadata) === null || _charge$metadata === void 0 ? void 0 : _charge$metadata.paperStatementYear) && ((_charge$metadata2 = charge.metadata) === null || _charge$metadata2 === void 0 ? void 0 : _charge$metadata2.paperStatementMonth) && /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "light",
      className: classes.hideMobile
    }, t('resident_account.statement_period'), ' ', moment("".concat(charge.metadata.paperStatementYear, "-").concat(charge.metadata.paperStatementMonth)).format('MMMM YYYY')), charge !== null && charge !== void 0 && charge.type && (charge === null || charge === void 0 ? void 0 : charge.type) !== 'credit' ? /*#__PURE__*/React.createElement(Typography, {
      className: classes.hideMobile,
      color: "light",
      variant: "h6"
    }, getTitle(charge.type, charge)) : null)), /*#__PURE__*/React.createElement("div", {
      className: classes.costWrapper
    }, charge.prevCost && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      className: classes.prevUtilityCost,
      variant: "h4"
    }, charge.prevCost), /*#__PURE__*/React.createElement("div", {
      className: classes.utilityPriceChangeIcon
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: t('statements.utility_cap', {
        cap: '10.00',
        charge: '13.05',
        credit: '3.05'
      }),
      type: "grey"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      state: "info",
      type: "question"
    }))))), charge.startDateOnly && /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "light",
      className: classes.showMobile
    }, t('resident_account.service_dates'), charge.startDateOnly), charge !== null && charge !== void 0 && charge.type ? /*#__PURE__*/React.createElement(Typography, {
      className: classes.showMobile,
      color: "light",
      variant: "h6"
    }, getTitle(charge.type, charge)) : null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      className: "".concat(classes.cost, " ").concat((charge === null || charge === void 0 ? void 0 : charge.type) === 'credit' ? classes.utilityCredit : '')
    }, getChargeAmount(charge)), (!charge.type || charge.type === TRANSACTION_TYPESV2.UtilityCharge) && !charge.isSkipped && !charge.isOptOut && /*#__PURE__*/React.createElement("div", {
      className: classes.actionIcons
    }, !hideNotes && /*#__PURE__*/React.createElement(BasicTooltip, {
      title: t('statements.notes_and_memos'),
      placement: "top"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      'custom-attribute': '813-resident-profile-page-statement-block'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "note"
    }))), isFinalStatement ? null : /*#__PURE__*/React.createElement(AllocationPreviewModal, {
      billingCycleId: charge.billingCycleId,
      propertyId: propertyId,
      utility: charge
    }))));
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.statementSummary
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('resident_account.total')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.total
  }, "$", Number(total).toFixed(2))));
});
StatementsBlock.propTypes = {
  hideNotes: PropTypes.bool,
  hidePostAction: PropTypes.bool,
  statement: PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
    total: PropTypes.string,
    charges: PropTypes.arrayOf(PropTypes.shape({
      description: PropTypes.string,
      type: PropTypes.string,
      cost: PropTypes.string
    }))
  })
};